import axios from "axios";

const { REACT_APP_GOERLI_URL, REACT_APP_GOERLI_KEY } = process.env;
const goerliUrl = `${REACT_APP_GOERLI_URL}/v2/${REACT_APP_GOERLI_KEY}`;

export const httpHost = axios.create({
  baseURL: goerliUrl,
});
